import { useState, useEffect, useCallback } from "react";
import { getPreviousTransactions } from "api/accountsAPI";
import { handleApiError } from "Helper/index.js";
import { toast } from "react-toastify";

export const usePreviousTransactions = (entity, entityType) => {
  const [dataState, setDataState] = useState({
    take: 200,
    skip: 0,
  });
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState({
    data: [],
    total: 0,
  });

  const fetchTransactions = useCallback(async () => {
    if (!entity) return;

    let matterId = null;
    let nominalRef = null;
    let supplierRef = null;

    if (entityType === "matter") {
      matterId = entity.matterId;
    } else if (entityType === "nominal") {
      nominalRef = entity.nominalRef;
    } else if (entityType === "supplier") {
      supplierRef = entity.supplierRef;
    }

    if (!matterId && !nominalRef && !supplierRef) return;

    try {
      setLoading(true);
      const page = Math.floor(dataState.skip / dataState.take) + 1;

      const { data } = await getPreviousTransactions(
        matterId,
        nominalRef,
        supplierRef,
        page,
        dataState.take
      );

      setTransactions({
        data: data.data || [],
        total: data.total || 0,
      });
    } catch (error) {
      handleApiError(error);
      toast.error("Failed to fetch previous transactions");
    } finally {
      setLoading(false);
    }
  }, [entity, entityType, dataState.skip, dataState.take]);

  useEffect(() => {
    if (!entity) return;

    fetchTransactions();
  }, [entity, dataState.skip, dataState.take]);

  return {
    dataState,
    setDataState,
    loading,
    transactions,
    fetchTransactions,
  };
};
